<!-- Top Toolbar -->
<mat-toolbar class="top-toolbar">
    <div class="toolbar-left">
        <button (click)="toggleSidenav()" mat-icon-button aria-label="Toggle menu">
            <mat-icon>menu</mat-icon>
        </button>
        <span class="app-title">Mevolve Connect</span>
        <span class="env-badge" [class.env-prod]="isProduction" [class.env-dev]="!isProduction">
            {{ envLabel }}
        </span>
    </div>
    <div class="toolbar-right">
        <div class="user-info" *ngIf="currentUser">
            <mat-icon>account_circle</mat-icon>
            <span class="user-name">{{ currentUser.label }}</span>
        </div>
        <button class="btn-logout" (click)="logout()" matTooltip="Logout">
            <mat-icon>logout</mat-icon>
            <span>Logout</span>
        </button>
    </div>
</mat-toolbar>

<!-- Sidebar + Content -->
<mat-drawer-container>
    <mat-drawer class="sidebar" [opened]="showSidenav" #drawer mode="side">
        <div class="nav-menu">
            <a class="nav-item" routerLink="/emails" [routerLinkActive]="['active']" [class.active]="isInEmailEditor">
                <mat-icon>email</mat-icon>
                <span>Email Templates</span>
            </a>
            <a class="nav-item" routerLink="/assets" [routerLinkActive]="['active']">
                <mat-icon>folder</mat-icon>
                <span>Assets</span>
            </a>
            <a class="nav-item" routerLink="/email-templates" [routerLinkActive]="['active']">
                <mat-icon>send</mat-icon>
                <span>Published</span>
            </a>
            <a *ngIf="isAdmin" class="nav-item admin-item" routerLink="/admin" [routerLinkActive]="['active']">
                <mat-icon>admin_panel_settings</mat-icon>
                <span>Admin</span>
            </a>
        </div>
    </mat-drawer>
    <mat-drawer-content [class.side-nav-opened]="showSidenav">
        <router-outlet />
    </mat-drawer-content>
</mat-drawer-container>
